import $ from 'jquery';

$('#contact-form').each(function() {

    var $form = $(this);

    $form.on('focus change', 'input', function() {
        $(this).tooltip('hide').removeClass('has-error');
    });
    
    $form.submit(e => {

        e.preventDefault();

        if (!validateForm()) {
            return false;
        }

        var data = $form.serializeArray(),
            url = $form.attr('action');

        $.post(url, data, result => {
            
            $form.replaceWith(`<div class="form-success border p-4 my-lg-5 mx-auto">
                <h2>Vielen Dank für Ihre Anfrage.</h2>
                <p class="mb-0">Wir haben Ihre Nachricht erhalten und bearbeiten Ihre Anfrage schnellstmöglich.</p>
            </div>`);

            window.setTimeout(e => {
                $('html, body').animate({
                    scrollTop: $('.form-success').offset().top - 300
                }, 500)
            }, 0);

        });


    });

    var validateForm = () => {

        if ($form.find('input[name=company]').val() == '') {
            $form.find('input[name=company]').tooltip({
                title: 'Bitte geben Sie den Namen Ihrer Praxis ein.',
                trigger: 'manual'
            }).tooltip('show').addClass('has-error');
        }

        if ($form.find('input[name=contact]').val() == '') {
            $form.find('input[name=contact]').tooltip({
                title: 'Bitte geben Sie den Namen Ihres Ansprechpartners ein.',
                trigger: 'manual'
            }).tooltip('show').addClass('has-error');
        }

        if ($form.find('input[name=street]').val() == '') {
            $form.find('input[name=street]').tooltip({
                title: 'Bitte geben Sie Ihre Straße und Hausnummer ein.',
                trigger: 'manual'
            }).tooltip('show').addClass('has-error');
        }

        if ($form.find('input[name=city]').val() == '') {
            $form.find('input[name=city]').tooltip({
                title: 'Bitte geben Sie Ihre Postleitzahl und Ort ein.',
                trigger: 'manual'
            }).tooltip('show').addClass('has-error');
        }

        if (/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test($form.find('input[name=email]').val()) == false) {
            $form.find('input[name=email]').tooltip({
                title: 'Bitte geben Sie eine gültige E-Mail-Adresse ein.',
                trigger: 'manual'
            }).tooltip('show').addClass('has-error');
        }

        if ($form.find('textarea[name=message]').val() == '') {
            $form.find('textarea[name=message]').tooltip({
                title: 'Bitte geben Sie Ihre Anfrage an uns ein.',
                trigger: 'manual'
            }).tooltip('show').addClass('has-error');
        }

        if ($form.find('input#check-privacy').is(':checked') == false) {
            $form.find('input#check-privacy').tooltip({
                title: 'Bitte bestätigen Sie, unsere Datenschutzerklärung gelesen zu haben.',
                trigger: 'manual'
            }).tooltip('show').addClass('has-error');
        }
        
        if ($form.find('.has-error').length > 0) {
            $('html, body').animate({
                scrollTop: $form.find('.has-error:first').offset().top - 300
            }, 1000)
        }

        return $form.find('.has-error').length == 0;

    }


});